var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
var ClickDetector = function (_a) {
    var children = _a.children, onInsideClick = _a.onInsideClick, onOutsideClick = _a.onOutsideClick, id = _a.id, dataId = _a.dataId;
    var detectorRef = useRef(null);
    var onClick = function (e) {
        var _a;
        if ((_a = detectorRef === null || detectorRef === void 0 ? void 0 : detectorRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            onInsideClick && onInsideClick(e);
        }
        else {
            onOutsideClick && onOutsideClick(e);
        }
    };
    useEffect(function () {
        window.addEventListener('click', onClick, true);
        return function () { return window.removeEventListener('click', onClick, true); };
    }, []);
    return (_jsx("div", __assign({ ref: detectorRef, id: id, "data-testid": dataId }, { children: children })));
};
ClickDetector.propTypes = {
    onInsideClick: PropTypes.func,
    onOutsideClick: PropTypes.func,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
export { ClickDetector };
//# sourceMappingURL=ClickDetector.js.map